import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    console.log(`API Request: ${config.method.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// ============ CONTACT API ============

export const contactAPI = {
  // Create new contact request
  create: async (contactData) => {
    try {
      const response = await apiClient.post('/contact', contactData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get all contacts (admin)
  getAll: async (skip = 0, limit = 100) => {
    try {
      const response = await apiClient.get('/contacts', {
        params: { skip, limit },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get contact by ID
  getById: async (contactId) => {
    try {
      const response = await apiClient.get(`/contacts/${contactId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

// ============ BLOG API ============

export const blogAPI = {
  // Get all blog articles
  getAll: async (skip = 0, limit = 100, category = null) => {
    try {
      const params = { skip, limit };
      if (category) params.category = category;
      
      const response = await apiClient.get('/blog', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get article by slug
  getBySlug: async (slug) => {
    try {
      const response = await apiClient.get(`/blog/${slug}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Create new article
  create: async (articleData) => {
    try {
      const response = await apiClient.post('/blog', articleData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Update article
  update: async (articleId, articleData) => {
    try {
      const response = await apiClient.put(`/blog/${articleId}`, articleData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Delete article
  delete: async (articleId) => {
    try {
      const response = await apiClient.delete(`/blog/${articleId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

// ============ HEALTH CHECK ============

export const healthAPI = {
  check: async () => {
    try {
      const response = await apiClient.get('/health');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default apiClient;